import util from '../util'
import axios from 'axios'
import token from '../../common/utils/token'

let base= window.$servicePath;

export default {
  /**
   * 保存表单数据
   */
  saveFormData(params) {
    return util.ajax(`${base}/api/data/saveFormData`,params)
  },
  markDeleteFormData(params){
    return util.ajax(`${base}/api/data/markDeleteFormData`,params)
 },
  markDeleteFormDataReleaseWH(params){
    return util.ajax(`${base}/api/data/markDeleteFormDataReleaseWH`,params,true)
  },
  restoreDeletedFormData(params){
    return util.ajax(`${base}/api/data/restoreDeletedFormData`,params)
  },
  deleteFormData(params) {
    return util.ajax(`${base}/api/data/deleteFormData`,params)
  },

 /* updateFormData(params) {
    return util.ajax(`${base}/api/data/updateFormData`,params)
  },*/

  getFormData(params) {
    return util.ajax(`${base}/api/data/getFormData`,params)
  },

  getFormDataByModule(params) {
    return util.ajax(`${base}/api/data/getFormDataByModule`,params)
  },

  //切换数据的表单版本
  changeFormVersion(params) {
    return util.ajax(`${base}/api/data/changeFormVersion`,params)
  },

  listFormData(params) {
    return util.ajax(`${base}/api/data/listFormData`,params)
  },
  /**
   * 文档中心获取数据
   * @param params
   * @returns {*}
   */
  listDocData(params){
    return util.ajax(`${base}/api/data/listDocData`,params)
  },

  /**
   * 保存数据字典数据
   * @param data
   *   code
   *   name
   * @return
   */
  async saveDict(params) {
    //return util.ajax(`${base}/api/data/saveDict`,params)
    const formData = new FormData();
    for (let name in params) {
      if (params.hasOwnProperty(name)) {
        formData.append(name, params[name]);
      }
    }
    return (await axios.post(`${base}/api/data/saveDict`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'//https://www.w3.org/TR/html401/interact/forms.html#h-17.13.4
        //'Authorization': `Bearer ${token.getToken()}`
      }
    })).data
  },

  /**
   * 删除数据字典数据
   * @param data
   *  ids
   * @return
   */
  deleteDict(ids, params = {}) {
    return util.ajax(`${base}/api/data/deleteDict`,{ids:ids, ...params})
  },

  /**
   * 查找数据字典数据
   * @param data
   *   id
   * @return
   */
  getDict(id, params = {}) {
    return util.ajax(`${base}/api/data/getDict`,{id:id, ...params})
  },

  /**
   * 查找数据字典数据
   * @param data
   *   id
   * @return
   */
  getDictByCode(code) {
    return util.ajax(`${base}/api/data/getDictByCode`,code)
  },


  /**
   * 显示列表数据
   * @param data
   *   code
   *   start
   *   limit
   * @return
   */
  listDictByApp(params) {
    return util.ajax(`${base}/api/data/listDictByApp`,params)
  },

  /**
   * 显示列表数据
   * @param data
   *   code
   *   start
   *   limit
   * @return
   */
  listDict(params) {
    return util.ajax(`${base}/api/data/listDict`,params)
  },

  /**
   * 显示列表数据
   * @param data
   *   code
   *   start
   *   limit
   * @return
   */
  listDictTree(params) {
    return util.ajax(`${base}/api/data/listDictTree`,params)
  },

  /**
   * 工作时间
   * @param params
   */
  listWorkTime(params){
    return util.ajax(`${base}/api/data/listWorkTime`,params)
  },
  saveWorkTime(data){
    return util.ajax(`${base}/api/data/saveWorkTime`,data)
  },
  deleteWorkTime(ids){
    return util.ajax(`${base}/api/data/deleteWorkTime`,ids)
  },
  setDefaultWorkTime(id){
    return util.ajax(`${base}/api/data/setDefaultWorkTime`,id)
  },
  getWorkTime(id){
    return util.ajax(`${base}/api/data/getWorkTime`,id)
  },

  //-----数据转换(导入)
  getTransferSet(id){
    return util.ajax(`${base}/api/data/getTransferSet`,id);
  },
  getTransferSetJob(id){
    return util.ajax(`${base}/api/data/getTransferSetJob`,id);
  },
  saveTransferSet(params){
    return util.ajax(`${base}/api/data/saveTransferSet`,params);
  },
  listTransferSet(params){
    return util.ajax(`${base}/api/data/listTransferSet`,params);
  },
  deleteTransferSet(ids){
    return util.ajax(`${base}/api/data/deleteTransferSet`,ids);
  },
  getImportLog(id){
    return util.ajax(`${base}/api/data/getImportLog`,id);
  },
  listImportLog(params){
    return util.ajax(`${base}/api/data/listImportLog`,params);
  },
  listImportItemLog(params){
    return util.ajax(`${base}/api/data/listImportItemLog`,params);
  },
  getImportItemLog(id){
    return util.ajax(`${base}/api/data/getImportItemLog`,id);
  },
  deleteImportItemLog(ids){
    return util.ajax(`${base}/api/data/deleteImportItemLog`,ids);
  },
  getTransferDataSource(id){
    return util.ajax(`${base}/api/data/getTransferDataSource`,id);
  },
  saveTransferDataSource(params){
    return util.ajax(`${base}/api/data/saveTransferDataSource`,params);
  },
  listTransferDataSource(params){
    return util.ajax(`${base}/api/data/listTransferDataSource`,params);
  },
  deleteTransferDataSource(ids){
    return util.ajax(`${base}/api/data/deleteTransferDataSource`,ids);
  },
  importOrganize(params){
    return util.ajax(`${base}/api/data/importOrganize`,params);
  },
  importProcessDefinition(params){
    return util.ajax(`${base}/api/data/importProcessDefinition`,params);
  },
  importDocument(params){
    return util.ajax(`${base}/api/data/importDocument`,params);
  },
  reImportDocument(params){
    return util.ajax(`${base}/api/data/reImportDocument`,params);
  },
  getFormDataById(...args){
    return util.ajax(`${base}/api/data/getFormDataById`,...args);
  },
  migrateProcess(params){
    return util.ajax(`${base}/api/data/migrateProcess`,params);
  },
  //------------系统字典配置
  /**
   * 保存系统字典数据
   * @param data
   *   code
   *   name
   * @return
   */
  async saveSysDic(params) {
    const formData = new FormData();
    for (let name in params) {
      if (params.hasOwnProperty(name)) {
        formData.append(name, params[name]);
      }
    }
    return (await axios.post(`${base}/api/data/saveSysDic`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data' //https://www.w3.org/TR/html401/interact/forms.html#h-17.13.4
        //'Authorization': `Bearer ${token.getToken()}`
      }
    })).data
  },
  saveSysFormDic(params){
    return util.ajax(`${base}/api/data/saveSysFormDic`,params)
  },
  getSysFormDic(){
    return util.ajax(`${base}/api/data/getSysFormDic`)
  },
  getSysDicByCode(code){
    return util.ajax(`${base}/api/data/getSysDicByCode`,code)
  },
  saveServiceDic(params){
    return util.ajax(`${base}/api/data/saveServiceDic`,params)
  },
  getServiceDic(){
    return util.ajax(`${base}/api/data/getServiceDic`)
  },

  /**
   * 删除系统字典数据
   * @param data
   *  ids
   * @return
   */
  deleteSysDic(ids) {
    return util.ajax(`${base}/api/data/deleteSysDic`,ids)
  },
  /**
   * 获取系统字典数据
   * @param data
   *   id
   * @return
   */
  getSysDic(id) {
    return util.ajax(`${base}/api/data/getSysDic`,id)
  },
  /**
   * 显示系统字典列表
   * @param data
   *   code
   *   start
   *   limit
   * @return
   */
  listSysDic(params) {
    return util.ajax(`${base}/api/data/listSysDic`,params)
  },
  /**
   * 显示系统字典分类树
   * @param data
   *   code
   *   start
   *   limit
   * @return
   */
  listSysDicTree(params) {
    return util.ajax(`${base}/api/data/listSysDicTree`,params)
  },

}



// WEBPACK FOOTER //
// ./src/common/api/data.js